import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainPipe } from 'src/app/common/mainpipe.module';
import { SwiperModule } from 'swiper/angular';
import { HeaderComponent } from './header.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule, 
    MainPipe,
    FormsModule
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {
  getComponent() {
    return HeaderComponent;
  }
}
